import React from 'react';
import Loading from 'components/Loading';
import NewDesign from 'components/NewDesign';

const SelectFetchingData = (props) => {
  //! State

  //! Function

  //! Render
  return (
    <div className='component:SelectFetchingData tw-p-2 tw-flex tw-flex-col tw-gap-1 tw-justify-center tw-items-center'>
      <Loading />
      <NewDesign.Typography className='tw-text-muted-foreground'>
        Fetching data...
      </NewDesign.Typography>
    </div>
  );
};

export default SelectFetchingData;
